import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-brand p-8" }

import ContentMaxWidth from "@/components/ContentMaxWidth.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(ContentMaxWidth, { width: 800 }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "font-bold text-lg mb-2" }, "Poslednik"),
            _createTextVNode(" Karosserie und Lack GmbH "),
            _createElementVNode("br"),
            _createTextVNode(" Kameruner Str. 32"),
            _createElementVNode("br"),
            _createTextVNode(" Lage-Müssen 32791"),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createElementVNode("strong", null, "Phone"),
            _createTextVNode(" 0 52 32.97790"),
            _createElementVNode("br"),
            _createElementVNode("strong", null, "Email"),
            _createTextVNode(" info@poslednik.de"),
            _createElementVNode("br"),
            _createElementVNode("strong", null, "Geschäftsführer"),
            _createTextVNode(" Bart Bartels, Nico Hilderink ")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "font-bold text-lg" }, "Unsere Öffnungszeiten"),
            _createElementVNode("strong", null, "Montag - Freitag"),
            _createTextVNode(" 7.30 - 17.30 Uhr"),
            _createElementVNode("br"),
            _createTextVNode(" Oder nach Vereinbarung"),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createElementVNode("strong", null, "Ust-ID-Nr."),
            _createTextVNode(" DE312720750"),
            _createElementVNode("br")
          ])
        ], -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})